import { useEffect, useState } from 'react';
import { isMiniApp } from './platform';
import { installNavigationGuard } from './navigation-guard';
export function NavigationBoundary() {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    if (isMiniApp()) return installNavigationGuard(() => setBlocked(true));
  }, []);
  return blocked ? (
    <aside className="navigation-notice" role="alert">
      <p>
        Liên kết này chưa có nội dung trong ứng dụng. Bạn có thể gửi yêu cầu tư vấn để được hỗ trợ.
      </p>
      <button type="button" onClick={() => setBlocked(false)}>
        Đóng
      </button>
    </aside>
  ) : null;
}
